import React from "react";
import MetaTags from "./components/MetaTags";
import { AppBarFour } from "./components/AppBar";
import { Container, Row, Col } from "react-bootstrap";
import { PiMapPinSimpleAreaBold } from "react-icons/pi";
import { BiPhoneCall } from "react-icons/bi";
import { MdOutlineAlternateEmail } from "react-icons/md";
import Mark from "./components/Mark";

const ContactUs = () => {
  return (
    <div className="overflow-hidden">
      <MetaTags
        title="Contact Us - KING OF AMARAN CRACKERS - Wholesale & Retail Crackers"
        type="website"
        siteName="kingofamarancrackers.zentexus.in"
        url="https://kingofamarancrackers.zentexus.in/contactus"
        keywords="Contact Us | KING OF AMARAN CRACKERS | Sivakasi Crackers"
        description="Contact KING OF AMARAN CRACKERS for wholesale and retail crackers in Sivakasi"
        revisitAfter="10 Days"
      />
      <AppBarFour />
      <img
        src={require("../assets/images/banner/banner_onefour.jpg")}
        className="img-fluid w-100"
        alt="KING OF AMARAN CRACKERS"
      />
      <Container className="padding">
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} className="py-3">
            <h1 className="bold black text-center"> Contact Us</h1>
          </Col>
          <Col lg="4" md="12" className="py-3">
            <a
              href="https://maps.app.goo.gl/uWdtNrHZ3uE1bAx8A"
              target="_blank"
              rel="noreferrer"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <div className="box" style={{ cursor: "pointer" }}>
                <div className="box-icon">
                  <PiMapPinSimpleAreaBold size={40} color={"#000"} />
                </div>
                <div className="bold">
                  148E, Sivakasi - Virudhunagar Main Road, Nethaji Nagar, Veera Chelliya Puram, Virudhunagar (Dt). - 626 001
                </div>
              </div>
            </a>
          </Col>
          <Col lg="4" className="py-3">
            <div className="box">
              <div className="box-icon">
                <BiPhoneCall size={40} color={"#000"} />
              </div>
              <div>
                <li className="bold">
                  <a
                    href="tel:+918610214826"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    +91 86102 14826
                  </a>
                </li>
                <li className="bold">
                  <a
                    href="tel:+919566902788"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    +91 95669 02788
                  </a>
                </li>
              </div>
            </div>
          </Col>
          <Col lg="4" className="py-3">
            <div className="box">
              <div className="box-icon">
                <MdOutlineAlternateEmail size={40} color={"#000"} />
              </div>
              <div className="pb-4">
                <div className="bold">
                  <a
                    href="mailto:seeni382@gmail.com"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    seeni382@gmail.com
                  </a>
                </div>
              </div>
            </div>
          </Col>

          <Col lg="12" md="12" xs="12" className="py-5">
            <>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3934.236430616223!2d77.8952116750256!3d9.574876790509895!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zOcKwMzQnMjkuNiJOIDc3wrA1Myc1Mi4wIkU!5e0!3m2!1sen!2sin!4v1790316947634!5m2!1sen!2sin"
                width="100%"
                height="600"
                style={{
                  border: 0,
                  borderRadius: "12px",
                  boxShadow: "0 8px 25px rgba(0,0,0,0.1)",
                }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="strict-origin-when-cross-origin"
                title="Google Maps Embed of KING OF AMARAN CRACKERS, Sivakasi"
              ></iframe>
            </>
          </Col>
        </Row>
      </Container>

      <>
        <Mark />
      </>
    </div>
  );
};

export default ContactUs;
